import { EventSearch } from "../src/components";
import "./App.scss";

function App() {
  return (
    <div className="App">
      <EventSearch />
    </div>
  );
}

export default App;
